export default __webpack_public_path__ + "locales/ru/PrivacyPage.json?hash=aef1197352031235a67911c3733c969e";